import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Menu from '@material-ui/core/Menu';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { showSnack } from '../../actions/uiActions';
import { getMessage } from '../../reducers/i18n';
import { getCurrentBaseUri } from '../../reducers/page';
import { getActiveSewpatId } from '../../reducers/sewpats';

import Icon from '../Icon';
import Pin from '../sharing/PinterestIcon';
import ShareMenu from '../sharing/ShareMenu';
import MenuItem from '../sharing/ShareMenuItem';
import SnackBar from '../SnackBar';
import FlatInput from '../styles/FlatInputShareMenu';
import IconText from '../styles/IconText';

const ActionBar = styled(BottomNavigation)`
    &.stolo-gallery-bar {
        height: ${props => props.theme.space[13]};
        position: relative;
    }
    
    & .stolo-gallery-bar-button {
      padding-top: 0.3em;
    }
    
    & .stolo-gallery-bar-button span {
      margin-top: -0.1em;
      line-height: 1;
    }
`;


class PatternGalleryBarFull extends React.Component {
    state = {
        anchorEl: null,
        open: false,
    };

    handleClick = event => {
        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    onCopyClick = () => {
        if (this.input && this.input.select) {
            // select text
            this.input.select();
            try {
                // copy text
                document.execCommand('copy');
                this.input.blur();
            }
            catch (err) {
                alert('please press Ctrl/Cmd+C to copy');
            }
        }
        this.props.showSavedToClipBoard(Date.now());
        this.handleRequestClose();
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
            anchorEl: null,
        });
    };

    getUri = () => {
        let uri = this.props.shareBaseUri;
        uri = `${uri}/schnoff/${this.props.sewpatId}/${this.props.pattern.id}`;
        if (this.props.query) {
            const query = queryString.stringify(this.props.query);
            if (query.length > 0) {
                uri = `${uri}?${query}`;
            }
        }
        return uri;
    };

    getMedia = () => this.props.imgSrc || (
        (
            (
                this.props.pattern || {}
            ).thumbnails || {}
        ).xlargeDiscreet || {}
    ).url;

    getDescription = () => {
        const pattern = this.props.pattern;
        const description = `${this.props.pattern.title} - Designerstück (Schnittmuster Berlin) auf umfärbbaren Stoffmotiv designt von ${this.props.designerName} | www.schnoffle.de`;
        return description;
    };

    handleAddToFavorites = () => {
        this.props.addToFavorites(this.props.pattern.id, this.props.sewpatId);
        this.props.showAddedToFavorites(Date.now());
    };
    handleRemoveFromFavorites = () => {
        this.props.removeFromFavorites(
            this.props.pattern.id,
            this.props.sewpatId,
            this.props.query,
        );
    };
    handleGoToPattern = () => {
        this.props.goToPattern(
            this.props.pattern.id,
            this.props.sewpatId,
            this.props.query,
        );
    };
    iconColor = 'blueGrey.700';
    iconDimension = {
        width: '1.5rem',
        height: '1.5rem',
    };

    FavoritesAction = () => {
        if (this.props.removeFavorites !== true) {
            return (
                <BottomNavigationAction
                    onClick={this.handleAddToFavorites}
                    component='div'
                    label={
                        <IconText>{this.props.labelAddToFavorites}</IconText>}
                    value='addtofavorite'
                    icon={<Icon
                        name='icon-heartadd'
                        {...this.iconDimension}
                        iconColor={this.iconColor}
                    />}
                />
            );
        }
        return (
            <BottomNavigationAction
                onClick={this.handleRemoveFromFavorites}
                component='div'
                label={
                    <IconText>{this.props.labelRemoveFromFavorites}</IconText>}
                value='removefavorite'
                icon={<Icon
                    name='icon-heartremove'
                    {...this.iconDimension}
                    iconColor={this.iconColor}
                />}
            />
        );
    };

    render () {
        const {
            labelAddToCart,
            labelAddToFavorites,
            labelRemoveFromFavorites,
            labelColoring,
            pattern,
            addToFavorites,
            removeFromFavorites,
            goToPattern,
            removeFavorites,
            query,
            showAddedToFavorites,
            imgSrc,
            designerName,
            sewpatId,
            shareMenuLabel,
        } = this.props;

        return (
            <ActionBar
                classes={{root: 'stolo-gallery-bar'}}
                showLabels
                value={'null'}
            >
                {this.FavoritesAction()}
                <BottomNavigationAction
                    onClick={this.state.open ? null : this.handleClick}
                    component='div'
                    label={<IconText>{this.props.shareMenuLabel}</IconText>}
                    value='share'
                    icon={<Icon
                        name='icon-share'
                        {...this.iconDimension}
                        iconColor={this.iconColor}
                    />}
                    id={this.props.patternid}
                    key={this.props.patternid}
                />

                <Menu
                    id='simple-menu'
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                >
                    <MenuItem handleClick={this.handleRequestClose}>
                        <Pin
                            iconProps={{
                                name: 'icon-pinterest2',
                                width: '1.3em',
                                height: '1.3em',
                                iconColor: 'blueGrey.700',
                            }}
                            buttonText={this.props.sharePinterestLabel}
                            shareTarget={this.getUri()}
                            media={this.getMedia()}
                            description={this.getDescription()}
                        />
                    </MenuItem>
                    <MenuItem
                        ref={element => {
                            this.button = element;
                        }} handleClick={this.onCopyClick}
                    >
                        <FlatInput>
                            <Icon
                                {...{
                                    name: 'icon-link',
                                    width: '1.4em',
                                    height: '1.2em',
                                    iconColor: 'blueGrey.700',
                                }}
                            /> {this.props.shareLinkLabel}
                            <input
                                ref={element => {
                                    this.input = element;
                                }}
                                type={'text'}
                                value={this.getUri()}
                                readOnly
                            />
                        </FlatInput>
                    </MenuItem>

                </Menu>

                <BottomNavigationAction
                    onClick={this.handleGoToPattern}
                    component='div'
                    label={<IconText>{labelColoring}</IconText>}
                    value='color'
                    icon={<Icon
                        name='icon-palette'
                        {...this.iconDimension}
                        iconColor={this.iconColor}
                    />}
                />

                <SnackBar/>
            </ActionBar>
        );
    }
}


const mapDispatchToProps = dispatch => (
    {
        showSavedToClipBoard: id => dispatch(showSnack(
            id,
            'SNACK_LINK_COPIED_TO_CLIPBOARD',
            null,
            3000,
            null,
        )),
    }
);

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const sharePinterest = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_BUTTON_LABEL',
    );
    const sharePinterestPrefix = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_DEFAULT_PREFIX',
    );
    const shareLabel = getMessage(initialState, 'ICON_LABEL_SHARE');
    const shareLink = getMessage(initialState, initialOwnProps.messageId ||
        'SHARE_COPY_LINK_BUTTON_LABEL');
    const sewpatId = getActiveSewpatId(initialState);
    const mapStateToProps = state => (
        {
            sharePinterestLabel: sharePinterest,
            sharePinterestPrefix,
            shareLinkLabel: shareLink,
            shareBaseUri: getCurrentBaseUri(state),
            shareMenuLabel: shareLabel,
            sewpatId,
            ...initialOwnProps,
        }
    );
    return mapStateToProps;
};

ShareMenu.defaultProps = {
    pattern: {},
};

ShareMenu.propTypes = {
    pattern: PropTypes.object.required,
};

export default connect(
    makeMapStateToProps,
    mapDispatchToProps,
)(
    PatternGalleryBarFull);




// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternGalleryBarFull.js